import { CommonModule } from '@angular/common';
import { Component, HostBinding } from '@angular/core';
import {RouterLink, RouterLinkActive} from "@angular/router";

interface NavItem {
  icon: string;
  label: string;
  active?: boolean;
  route: string;
}

@Component({
  selector: 'side-nav-sidebar',
  standalone: true,
  imports: [CommonModule, RouterLinkActive, RouterLink],
  templateUrl: './side-nav-bar.component.html',
  styleUrl: './side-nav-bar.component.scss'
})

export class SideNavBarComponent {
  isExpanded = true;

  @HostBinding('class.collapsed')
  get collapsed(): boolean {
    return !this.isExpanded;
  }

  // @ts-ignore
  // @ts-ignore
  readonly navItems: NavItem[] = [
    { icon: '◫', label: 'Dashboard', route: '/allocation-dashboard' },
    //{ icon: '⌕', label: 'Suche' , route: '/real-estate'},
    //{ icon: '⌂', label: 'Kunden' , route: '/real-estate'},
    { icon: '▤', label: 'Workflows' , route: '/work-flow'},
    //{ icon: '◒', label: 'Analysen' , route: '/real-estate'},
    //{ icon: '▧', label: 'Reports' , route: '/fund-overview'},
    { icon: '⌁', label: 'Portfolios', route: '/fund-overview' },
    { icon: '▥', label: 'Transaktionen', route: '/portfolio-details' },
    { icon: '🛒', label: 'Orderbuch', active: true ,  route: '/order-book'},
    { icon: '□', label: 'Orderkörbe', route: '/order-baskets' },
    //{ icon: '⚖', label: 'Compliance' , route: '/real-estate'},
    //{ icon: '☁', label: 'Archiv', route: '/real-estate' },
   // { icon: '▱', label: 'Stammdaten' , route: '/real-estate'}
  ];

  toggle(): void {
    this.isExpanded = !this.isExpanded;
  }
}
